// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-permit.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-permit/flight-permit.js';

mount([g0]);
